import React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';
import { SkeltonCardTwo } from '../../../common/SkeltonCardTwo';
import { textCss } from '../../../common/Css';
import NoResultFound from '../../../common/NoResultFound';
import { validateStringValue } from '../../../utils/common';
import OverflowTip from '../../../common/OverflowTip';
import { closeModalAction, openTextModalAction } from '../../../actions/modal';
import { getLinkedProjects, unlinkProject } from '../../../actions/teams';

export default function TeamLinkedProjects(props) {
    const { onClose, headerComponent } = props;
    const selectedTeamUserDetails = useSelector((state) => state.customer.selectedTeamUserDetails);
    const teamId = selectedTeamUserDetails && selectedTeamUserDetails?.id;
    const linkedProjects = useSelector((state) => state.teams.linkedProjects);
    const isTeamsLinkedProjectsLoading = useSelector((state) => state.loading.isTeamsLinkedProjectsLoading);
    const dispatch = useDispatch();

    useEffect(() => {
        if (teamId) {
            dispatch(getLinkedProjects({ teamId }))
        }
    }, [dispatch, teamId]);

    const onRemoveClick = (projectId) => {
        dispatch(
            openTextModalAction({
                heading: 'Remove Team from project',
                text: 'Are you sure you want to continue?',
                closeOnBackdropClick: false,
                formName: 'removeTeamFromProject',
                buttons: [
                    {
                        showLoading: true,
                        textOrComponent: 'Yes',
                        type: 'red',
                        buttonClass: 'hover:bg-scogoLightFillRed',
                        onClick: () => {
                            dispatch(unlinkProject({ teamId, project_ids: [projectId], formName: 'removeTeamFromProject' }));
                        },
                    },
                    {
                        textOrComponent: 'No',
                        type: 'blue',
                        buttonClass: 'hover:bg-scogobgsky',
                        onClick: () => dispatch(closeModalAction()),
                    },
                ],
            })
        );
    }

    if (isTeamsLinkedProjectsLoading) {
        return <div className='px-6'><SkeltonCardTwo arr={[1, 2, 3, 4]} height={15} /></div>
    }

    return (
        <div className='sidedrawer overflow-hidden'>
            <div className='chatContainerHeader flex items-center'>
                {headerComponent({ headName: validateStringValue(selectedTeamUserDetails?.name), onClick: onClose })}
            </div>
            <div className='bg-white overflow-hidden groupDetailsHeight w-full'>
                <div className='h-full overflow-y-auto w-full relative'>
                    <div className='flex items-center pb-2 sticky top-0 z-20 bg-white border-b-2'>
                        <div>
                            <p className='pl-6 pr-2 py-2 text-font13 text-scogoprimary font-medium'>
                                Projects
                            </p>
                        </div>
                        <div className=''>
                            <p className='bg-scogoorange text-white rounded-full h-7 px-2 leading-7 text-center text-font11 font-medium'>
                                {linkedProjects?.length > 0 ? linkedProjects.length : 0}
                            </p>
                        </div>
                    </div>
                    {isTeamsLinkedProjectsLoading && <div className='px-6'><SkeltonCardTwo arr={[1, 2, 3, 4]} height={15} /></div>}
                    <div className='w-full'>
                        <AnimatePresence mode="wait">
                            {!isTeamsLinkedProjectsLoading && Array.isArray(linkedProjects) && linkedProjects.map((project, index) => (
                                <motion.div
                                    key={project.id}
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.2 }}
                                    className={`border-b py-4 relative flex items-center ${index % 2 !== 0 ? 'bg-white' : 'bg-gray-100'}`}
                                >
                                    <div className='line-clamp-3 px-3 flex-1'>
                                        <OverflowTip textClass={textCss?.inputText} someLongText={project.name} />
                                    </div>
                                    <div className='px-3'>
                                        <span
                                            onClick={() => onRemoveClick(project.id)}
                                            className='material-icons text-md text-scogoclosed cursor-pointer hover:text-scogoorange'
                                        >
                                            delete
                                        </span>
                                    </div>
                                </motion.div>
                            ))}
                        </AnimatePresence>
                    </div>
                    {(!isTeamsLinkedProjectsLoading && linkedProjects && linkedProjects?.length === 0) && (
                        <div className="mt-4">
                            <NoResultFound message='No Linked Project Found' />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
